
import { ParameterMapStore } from './parameter-map';
import { SYSTEM_AGENT_NAME } from '@config/index';
import { TriggerCondition, ReferenceNode } from '@interface/index';

export const isSystemBoolean = (type: { id: string }) => {
  const param = ParameterMapStore.get(type.id);

  if (!param || param.source !== SYSTEM_AGENT_NAME) {
    return false;
  }

  return param.name === 'Boolean';
};
